import React, { useState } from "react";
import ModalComponent from "../../../ModalComponent";
import { postMethod } from "../../../../api/HTTPServices";
import { Recorder } from "react-voice-recorder";
import { useTranslation } from "react-i18next";
import "react-voice-recorder/dist/index.css";

const Index = ({
  handleOpenVoiceRecorder,
  handleCloseVoiceRecorder,
  audienceId,
  addMessageToList,
  userId,
  attachType,
  visitToken,
}) => {
  const { t } = useTranslation();

  const [audioDetails, setAudioDetails] = useState({
    url: null,
    blob: null,
    chunks: null,
    duration: {
      h: 0,
      m: 0,
      s: 0,
    },
  });

  const handleAudioStop = (data) => {
    setAudioDetails(data);
  };

  const handleAudioUpload = (blob) => {
    var d = new Date();
    var time = d.getTime();

    const file = new File(
      [blob],
      `${audienceId}-${userId}-${Date.now().toFixed()}-${time}.mp3`
    );
    let data = new FormData();
    // data.append("message", description);
    data.append("message", null);
    data.append("audience", audienceId);
    if (attachType === "prescription") {
      data.append("type", "prescriptionVoice");
    } else {
      data.append("type", "dossierVoice");
    }
    data.append("file", file);
    data.append("room_token", visitToken);

    const RequestService = postMethod(
      "chat",
      data,
      "true",
      "post",
      "false",
      "",
      false
    );
    RequestService.then(function (response) {
      if (response) {
        addMessageToList(response.message);
        handleCloseVoiceRecorder();
      }
    });
  };
  const handleReset = () => {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0,
      },
    };
    setAudioDetails(reset);
  };

  return (
    <ModalComponent
      open={handleOpenVoiceRecorder}
      handleClose={handleCloseVoiceRecorder}
      closeBtn={true}
      confirmBtn={false}
      //   handleOk={uploadvoice}
      title={t(
        "components.AppointmentRoom.RoomFooter.voiceRecordingModal.title"
      )}
    >
      <div>
        <Recorder
          record={true}
          title={"New recording"}
          audioURL={audioDetails.url}
          showUIAudio
          handleAudioStop={(data) => handleAudioStop(data)}
          handleAudioUpload={(data) => handleAudioUpload(data)}
          handleReset={() => handleReset()}
          mimeTypeToUseWhenRecording={`audio/webm`} // For specific mimetype.
        />
      </div>
    </ModalComponent>
  );
};

export default Index;
